import React from 'react';
import { Truck, Hash, ShieldCheck, Gem, Hourglass, Receipt, FileQuestion } from 'lucide-react';
import { ReceiptRefundIcon } from '@heroicons/react/outline';

const ProductPolicies = ({ productData }) => {
  return (
    <div className="text-sm text-[#2d161e] mt-5 flex flex-col gap-3">
      {/* Delivery Info */}
      <div className="flex items-center gap-2">
        <Truck size={16} color="#e0c3b5" />
        <p>Ships within 3–7 Working Days – Fast Delivery</p>
      </div>

      {/* Premium Assurance */}
      <div className="flex items-center gap-2">
        <ShieldCheck size={16} color="#b09287" />
        <p>Expertly Crafted – Quality You Can Feel</p>
      </div>

      {/* Longevity Highlight */}
      <div className="flex items-center gap-2">
        <Hourglass size={16} color="#e0c3b5" />
        <p>Enduring Beauty – Built to Last, Worn to Remember</p>
      </div>

      <div className="flex items-center gap-2">
        <FileQuestion size={16} color="#e0c3b5" />
        <p>No Return Policy</p>
      </div>

      {/* Materials & Care */}
      <div className="flex items-center gap-2">
        <Gem size={16} color="#b09287" />
        <p>Quality Materials – Resistant to Tarnish with Proper Care</p>
      </div>

      {/* Product Code */}
      {productData?.productId && (
        <div className="flex items-center gap-1">
          <Hash size={16} color="#4c0f2e" />
          <p className="text-[#2d161e] font-medium">
            Product Code:{' '}
            <span className="font-poppins text-sm font-light">{productData.productId}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default ProductPolicies;
